import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export const TeamViewFieldSkeleton = (): React.JSX.Element => {
	return <Skeleton testId="team-view-field-skeleton" width="250px" height="16px" isShimmering />;
};
